import type { ReactNode } from 'react'

import S from './DualListEmpty.style'

const DualListEmpty = ({ children }: { children: ReactNode }) => {
  return <div css={S.empty}>{children}</div>
}

export default DualListEmpty
